import classNames from 'classnames';
import { PropsWithChildren, ReactElement } from 'react';
import { Badge as BsBadge, BadgeProps as BsBadgeProps } from 'react-bootstrap';

export type BadgeVariant = 'phoenix' | 'default' | 'tag';
export type BadgeBg =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | 'danger-animate'; // 👈 добавляем новый тип

interface BadgeProps extends BsBadgeProps {
  variant?: BadgeVariant;
  bg?: BadgeBg;
  className?: string;
  icon?: ReactElement;
  iconPosition?: 'start' | 'end';
  iconFamily?: 'fa' | 'unicons' | 'feather';
}

const Badge = ({
  children,
  bg,
  icon,
  className,
  variant = 'default',
  iconPosition = 'start',
  iconFamily = 'feather',
  ...rest
}: PropsWithChildren<BadgeProps>) => {
  return (
    <>
      {/* 👇 Вставляем стили прямо тут */}
      <style>
        {`
    @keyframes pulse-danger {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.2);
      }
      100% {
        transform: scale(1);
      }
    }

    /* 👇 danger-animate (анимированный красный) */
    .badge-animate-danger {
      animation: pulse-danger 1s ease-in-out infinite;
      background-color: #dc3545 !important;
      color: white !important;
      display: inline-block;
    }

    /* 👇 danger (просто красный без анимации) */
    .badge-static-danger {
      background-color: #dc3545 !important;
      color: white !important;
      display: inline-block;
    }
  `}
      </style>

      <BsBadge
        className={classNames(className, {
          [`badge-phoenix badge-phoenix-${bg}`]:
            variant === 'phoenix' && bg !== 'danger-animate',
          'badge-tag': variant === 'tag',
          'badge-animate-danger': bg === 'danger-animate', // 👈 включаем анимацию
          'badge-static-danger': bg === 'danger' // 👈 включаем анимацию
        })}
        bg={
          ['phoenix', 'tag'].includes(variant) || bg === 'danger-animate'
            ? ''
            : bg
        }
        {...rest}
      >
        {variant === 'phoenix' ? (
          <>
            {icon ? (
              <>
                {icon && iconPosition === 'start' && icon}
                <span
                  className={classNames({
                    'badge-label': iconFamily === 'feather'
                  })}
                >
                  {children}
                </span>
                {icon && iconPosition === 'end' && icon}
              </>
            ) : (
              children
            )}
          </>
        ) : (
          children
        )}
      </BsBadge>
    </>
  );
};

export default Badge;
